export default __webpack_public_path__ + "static/media/redmic.6ed85ee0.svg";